import { CUBE_AGGREGATE_INTERACTION, CUBE_AGGREGATE_INTERACTION_PRODUCT } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';

const PRODUCT_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.product`],
    limit: 1000,
    filters: [
      { member: `${CUBE_AGGREGATE_INTERACTION}.hcp_bk`, operator: 'set' },
      {
        member: `${sourceCube}.product`,
        operator: 'notEquals',
        values: [null],
      },
    ],
    timeDimensions: [timeDimensions],
  };
  return query;
};

const interactionProductFilter: FilterConfig = {
  label: 'main.channelFocus.hcpCoverage.filters.product.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.product.placeholder',
  type: 'multiselect',
  searchable: true,
  clearable: true,
  getOptionsQuery: PRODUCT_OPTIONS,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION_PRODUCT}.product`),
  defaultValue: [],
  sourceCube: CUBE_AGGREGATE_INTERACTION_PRODUCT,
  applyFilter: value => {
    const product = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION_PRODUCT}.product`,
      operator: 'equals',
      values: [...product],
    };
  },
};

export default interactionProductFilter;
